import { Reducer } from 'react'
import { SHARE_WORKLOAD_SUCCESS } from './actions'

export interface ShareWorkloadPayload {
  shared_with_account: string
  permission_type: string
}

export interface ShareWorkloadState {
  workloadId: string | null
  shareId: string | null
}

export const SHARE_TYPE = {
  CONNECTED: 'CONNECTED_AWS_ACCOUNT',
  OTHER: 'OTHER_AWS_ACCOUNT',
  IAM: 'IAM_USERS',
}

const initialState: ShareWorkloadState = {
  workloadId: null,
  shareId: null,
}

type actionType = {
  type: typeof SHARE_WORKLOAD_SUCCESS
  payload: ShareWorkloadState
}

export const reducer: Reducer<ShareWorkloadState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SHARE_WORKLOAD_SUCCESS:
      return {
        ...state,
        workloadId: action.payload.workloadId,
        shareId: action.payload.shareId,
      }

    default:
      return state
  }
}
